export default __webpack_public_path__ + "static/media/portfolio-41.1e480afc.jpg";